module.exports = __webpack_public_path__ + "static/media/cafe_popular_thumb_even.e05be040.jpg";